import {StoppageKind, StoppageType} from '@hconnect/common/types'
import {DateRange} from '@hconnect/uikit'
import {isArray} from 'lodash'

import {DurationInterval, IssueGroupingKey, TimeStep} from '../types'

export type AggregatedStoppageCodePayload = DateRange<Date> & {
  kinds?: StoppageKind[]
  stoppedDepartmentUpmIds?: string[]
  mainEquipmentNumbers?: string[]
  equipmentNumbers?: string[]
  stoppageCodes?: string[]
  stoppageType?: StoppageType[]
  durationInterval?: DurationInterval
}

export type StoppageTimePeriodStatistics = AggregatedStoppageCodePayload & {
  timeStep?: TimeStep
  groupBy?: IssueGroupingKey
}

export const prepareAggregatedStoppageCodePayload = (
  payload: StoppageTimePeriodStatistics
): Record<string, string> => {
  const params = {}

  for (const [key, value] of Object.entries(payload)) {
    if (isArray(value)) {
      value?.forEach((param, index) => {
        params[`${key}[${index}]`] = param
      })
    } else if (key === 'durationInterval' && value) {
      const durationInterval: DurationInterval = value
      for (const [subKey, subValue] of Object.entries(durationInterval)) {
        params[`${key}.${subKey}`] = subValue
      }
    } else {
      params[key] = value
    }
  }

  return params
}
